import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPcCategoriesAndRequirementsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetPcCategoriesAndRequirementsQuery = { __typename?: 'query_root', proof_center_categories: Array<{ __typename?: 'proof_center_categories', id: any, key?: string | null, name: string, description?: string | null, proof_center_category_requirements: Array<{ __typename?: 'proof_center_category_requirements', id: any, name: string }> }> };


export const GetPcCategoriesAndRequirementsDocument = gql`
    query getPCCategoriesAndRequirements {
  proof_center_categories {
    id
    key
    name
    description
    proof_center_category_requirements {
      id
      name
    }
  }
}
    `;

/**
 * __useGetPcCategoriesAndRequirementsQuery__
 *
 * To run a query within a React component, call `useGetPcCategoriesAndRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPcCategoriesAndRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPcCategoriesAndRequirementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPcCategoriesAndRequirementsQuery(baseOptions?: Apollo.QueryHookOptions<GetPcCategoriesAndRequirementsQuery, GetPcCategoriesAndRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPcCategoriesAndRequirementsQuery, GetPcCategoriesAndRequirementsQueryVariables>(GetPcCategoriesAndRequirementsDocument, options);
      }
export function useGetPcCategoriesAndRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPcCategoriesAndRequirementsQuery, GetPcCategoriesAndRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPcCategoriesAndRequirementsQuery, GetPcCategoriesAndRequirementsQueryVariables>(GetPcCategoriesAndRequirementsDocument, options);
        }
export function useGetPcCategoriesAndRequirementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPcCategoriesAndRequirementsQuery, GetPcCategoriesAndRequirementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPcCategoriesAndRequirementsQuery, GetPcCategoriesAndRequirementsQueryVariables>(GetPcCategoriesAndRequirementsDocument, options);
        }
export type GetPcCategoriesAndRequirementsQueryHookResult = ReturnType<typeof useGetPcCategoriesAndRequirementsQuery>;
export type GetPcCategoriesAndRequirementsLazyQueryHookResult = ReturnType<typeof useGetPcCategoriesAndRequirementsLazyQuery>;
export type GetPcCategoriesAndRequirementsSuspenseQueryHookResult = ReturnType<typeof useGetPcCategoriesAndRequirementsSuspenseQuery>;
export type GetPcCategoriesAndRequirementsQueryResult = Apollo.QueryResult<GetPcCategoriesAndRequirementsQuery, GetPcCategoriesAndRequirementsQueryVariables>;